import stedsnavn from "./stedsnavn";

const geonorge = {
	stedsnavn
};

export default geonorge;
export { geonorge };
